package ui.campaign

import androidx.compose.runtime.*
import androidx.compose.ui.text.input.TextFieldValue
import common.frontend.api.Io
import common.frontend.api.canLayerTopAdd
import io.Repository
import kotlinx.coroutines.launch
import org.jetbrains.compose.resources.StringResource
import ssoft.frontend.generated.resources.*
import tk.mallumo.compose.navigation.navTo_CampaignPreviewUI
import tk.mallumo.compose.navigation.viewmodel.NavigationViewModel
import tk.mallumo.compose.navigation.viewmodel.VM
import tk.mallumo.utils.DataState
import tk.mallumo.utils.mutableDataState
import tools.await
import tools.findRoot
import ui.campaign.detailv2.preview.CampaignPreviewArgs
import ui.snackBarStateGlobal

@VM
class CampaignListingVM : NavigationViewModel() {

    private lateinit var scopeUi: CampaignListingScope

    var query by mutableStateOf("")

    var canAdd by mutableStateOf(false)
        private set

    var state by mutableDataState<CampaignListingScope.Wrapper>()
        private set


    val searchFiled = mutableStateOf(TextFieldValue(""))


    var filter by mutableStateOf(Io.Filter.CampaignListing())

    sealed interface Action {
        class OpenDetail(val companyId: Long, val campaignGroupId: Long) : Action
        data object Reload : Action

        companion object {

            @Composable
            fun rememberAction(vm: CampaignListingVM): (Action) -> Unit {
                return remember {
                    { act ->
                        when (act) {
                            is OpenDetail -> with(vm.scopeUi) {
                                nav.findRoot().navTo_CampaignPreviewUI(
                                    CampaignPreviewArgs(
                                        companyId = act.companyId,
                                        campaignGroupId = act.campaignGroupId
                                    )
                                )
                            }

                            Reload -> with(vm.scopeUi) {
                                vm.reload(args.companyId)
                            }
                        }
                    }
                }
            }
        }
    }

    fun reload(companyId: Long) {
        scope.launch {
            runCatching {
                val data = Repository.api.campaign.listing(companyId, filter)
                state = DataState.Result(CampaignListingScope.Wrapper(data))
                if (::scopeUi.isInitialized) {
                    canAdd = scopeUi.login.canLayerTopAdd(companyId)
                }
            }.onFailure {
                it.printStackTrace()
                state = DataState.Error(Res.string.err_connection_fail.await())
            }
        }
    }

    fun init(scopeUi: CampaignListingScope) {
        this.scopeUi = scopeUi
        if (state !is DataState.Result) {
            state = DataState.Loading()
        }
        reload(scopeUi.args.companyId)
    }

    override fun onRelease() {
        state.entry?.release()
        state = DataState.Idle()
    }

    fun canCreateCampaign(): Boolean {

        fun launchMessage(label: StringResource) {
            scope.launch {
                snackBarStateGlobal.showSnackbar(
                    message = label.await(),
                    withDismissAction = true
                )
            }
        }

        return state.entry?.data?.let {
            when {
                !it.canCreate -> {
                    launchMessage(Res.string.layer_top_listing__warning_no_mode)
                    false
                }

                it.counter.devices.all == 0 -> {
                    launchMessage(Res.string.layer_top_listing__warning_no_devices)
                    false
                }

                it.counter.devices.withTopLayer == 0 -> {
                    launchMessage(Res.string.layer_top_listing__warning_no_devices_with_top_layer)
                    false
                }

                else -> true
            }
        } == true
    }
}
